module.exports = __webpack_public_path__ + "img/printer.9688eb13.svg";